import "./index.scss";
import LoggedOutLayout from "features/layouts/pages/logged-out";
import Modal from "features/components/modal";
import Title from "features/components/title";
import Text from "features/components/text";
import React from 'react';
import Button from "../../../components/button";



export const AppCourtesyPage = (props) => {
    function openAppIos() {
        return window.location.href = 'https://apps.apple.com/it/app/osa-community/id6443794292';
    }

    function openAppAndroid() {
        return window.location.href = 'https://play.google.com/store/apps/details?id=it.dieffetech.osa&hl=en_US&gl=US';
    }
    return <LoggedOutLayout type={"dark"} className={"login-page"}>
        <Modal>
            <Title size={34} align={"center"}>Tutti i servizi sono stati migrati sulla nuovissima app OSA Community</Title>
            <br/>
            <Text>Direttamente sul tuo cellulare: <br/>
                <ul>
                    <li>LIBRERIA VIDEO DI TUTTI GLI EVENTI OSA</li>
                    <li>CTA DI MIRCO A PORTATA DI MANO</li>
                    <li>EVENTI IN PROGRAMMA</li>
                    <li>CONFERMA SERATA</li>
                    <li>ACCESSO AI CONTENUTI SPECIALI</li>
                    <li>LETTURE CONSIGLIATE</li>
                    <li>BACHECA SOCIAL</li>
                </ul>
            </Text>
            <br/><br/>

            <Button title={'Scarica l\'app su iOS'} onClick={() => openAppIos()}/>
            <Button title={'Scarica l\'app su Android'} onClick={() => openAppAndroid()}/>
        </Modal>
    </LoggedOutLayout>
}


export default AppCourtesyPage;
